import React from 'react';
export const Button = ({
  children,
  onClick,
  variant = 'primary',
  disabled = false,
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center px-5 py-2.5 text-[15px] font-medium transition-all duration-200 focus:outline-none transform active:scale-[0.98] rounded-md';
  const variantClasses = {
    primary: 'bg-[#111010] text-white hover:bg-black shadow-sm focus:ring-2 focus:ring-[#FCCA86] focus:ring-offset-1',
    secondary: 'bg-[#FCCA86] text-[#111010] hover:bg-[#f0bd77] shadow-sm focus:ring-2 focus:ring-[#111010] focus:ring-offset-1',
    outline: 'bg-white text-[#111010] border border-gray-300 hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-[#FCCA86] focus:ring-offset-1'
  };
  const disabledClasses = 'opacity-60 cursor-not-allowed hover:scale-100 active:scale-100';
  const classes = `${baseClasses} ${variantClasses[variant]} ${disabled ? disabledClasses : ''} ${className}`;
  return <button className={classes} onClick={onClick} disabled={disabled} {...props} data-id="element-431">
      {children}
    </button>;
};